/** Validates that a given string is made up of only numbers. */
export function isNumberStringValid(value: string) {
  return /^[0-9]+$/.test(value ?? "");
}
